module.exports = __webpack_public_path__ + "img/book.5985b241.jpeg";